import { BoxSelectIcon, CaseUpperIcon, CodeIcon, FormInputIcon, GalleryHorizontalIcon, HeadingIcon, ImageIcon, LayoutPanelTopIcon, LinkIcon, ListCollapseIcon, ListIcon, MenuIcon, SparkleIcon, SquareIcon, } from "lucide-react";
import { DraggableComponentTypes } from "../../types/draggable";
import { v4 as uuidv4 } from "uuid";
export const draggableCategories = {
    structure: "Structuur",
    basic: "Basis",
    typography: "Teksten",
    media: "Media",
    form: "Formulieren",
    navigator: "Navigatie",
    repeatables: "Repeatables",
    // other: "Overig",
};
export const draggableElements = [
    {
        type: DraggableComponentTypes.Text,
        element: "P",
        name: "Tekst",
        icon: CaseUpperIcon,
        category: draggableCategories.typography,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Title,
        element: "h1",
        name: "Titel",
        icon: HeadingIcon,
        category: draggableCategories.typography,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Div,
        element: "div",
        name: "Div",
        icon: BoxSelectIcon,
        category: draggableCategories.structure,
        allowedChildren: ["*"],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Grid,
        element: "grid",
        name: "Grid",
        icon: LayoutPanelTopIcon,
        category: draggableCategories.structure,
        allowedChildren: [DraggableComponentTypes.GridItem],
        defaultData: {
            props: {
                gridMobile: "grid-cols-2",
                gridTablet: "md:grid-cols-2",
                gridDesktop: "lg:grid-cols-2",
            },
            children: [
                {
                    id: `elementId/${uuidv4()}`,
                    type: DraggableComponentTypes.GridItem,
                },
                {
                    id: `elementId/${uuidv4()}`,
                    type: DraggableComponentTypes.GridItem,
                },
            ],
        },
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.GridItem,
        element: "gridItem",
        name: "Grid item",
        icon: LayoutPanelTopIcon,
        category: null,
        allowedChildren: ["*"],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Image,
        element: "img",
        name: "Afbeelding",
        icon: ImageIcon,
        category: draggableCategories.media,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Link,
        element: "A",
        name: "Link",
        icon: LinkIcon,
        category: draggableCategories.basic,
        allowedChildren: ["*"],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Button,
        element: "button",
        name: "Button",
        icon: SquareIcon,
        category: draggableCategories.basic,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Form,
        element: "form",
        name: "Formulier",
        icon: FormInputIcon,
        category: draggableCategories.form,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Navbar,
        element: "navbar",
        name: "Navigatie",
        icon: MenuIcon,
        category: draggableCategories.navigator,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.NavbarVertical,
        element: "navbarVariant",
        name: "Menu vertical",
        icon: MenuIcon,
        category: draggableCategories.navigator,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Html,
        element: "html",
        name: "HTML",
        icon: CodeIcon,
        category: draggableCategories.basic,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Container,
        element: "container",
        name: "Container",
        icon: BoxSelectIcon,
        category: draggableCategories.structure,
        allowedChildren: ["*"],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Icon,
        element: "icon",
        name: "Icon",
        icon: SparkleIcon,
        category: draggableCategories.basic,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.Svg,
        element: "svg",
        name: "Svg",
        icon: SparkleIcon,
        category: null,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: true,
    },
    {
        type: DraggableComponentTypes.List,
        element: "list",
        name: "Lijst",
        icon: ListIcon,
        category: null,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: false,
    },
    {
        type: DraggableComponentTypes.ListItem,
        element: "listItem",
        name: "Lijst item",
        icon: ListIcon,
        category: null,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: true,
    },
    {
        type: DraggableComponentTypes.ImageSlider,
        element: "imageSlider",
        name: "Afbeelding slider",
        icon: ImageIcon,
        category: draggableCategories.repeatables,
        allowedChildren: [],
        defaultData: {},
        hideFromAddMenu: true,
    },
    {
        type: DraggableComponentTypes.RepeatableSlider,
        element: "repeatableSlider",
        name: "Repeatable Slider",
        icon: GalleryHorizontalIcon,
        category: draggableCategories.repeatables,
        allowedChildren: ["*"],
        defaultData: {},
        hideFromAddMenu: true,
    },
    {
        type: DraggableComponentTypes.RepeatableGrid,
        element: "repeatableGrid",
        name: "Repeatable Grid",
        icon: LayoutPanelTopIcon,
        category: draggableCategories.repeatables,
        allowedChildren: ["*"],
        hideFromAddMenu: true,
        defaultData: {
            props: {
                gridMobile: "grid-cols-2",
                gridTablet: "md:grid-cols-2",
                gridDesktop: "lg:grid-cols-2",
            },
            children: [
                {
                    id: `elementId/${uuidv4()}`,
                    type: DraggableComponentTypes.GridItem,
                },
            ],
        },
    },
    {
        type: DraggableComponentTypes.Accordion,
        element: "accordion",
        name: "Accordeon",
        icon: ListCollapseIcon,
        category: draggableCategories.basic,
        allowedChildren: ["*"],
        defaultData: {
            children: [
                {
                    id: `elementId/${uuidv4()}`,
                    type: DraggableComponentTypes.Text,
                },
            ],
        },
        hideFromAddMenu: true,
    },
];
//# sourceMappingURL=draggableElements.js.map